import { SecurityModalInfo } from './types'

export const createSecurityModalInfoFromResponse = (
  response: any
): SecurityModalInfo => ({
  ...response,
  settlementDate: response.settlementDate && new Date(response.settlementDate)
})
